<!-- <div [formGroup]="group">
  <mat-form-field appearance="outline" class="basic-input-field" [ngClass]="config.maxLengthHint ? 'setMargin':''">
    <mat-label class="select-label">{{config.label}}</mat-label>
    <textarea matInput #textarea [placeholder]="config.placeholder" [maxlength]="config.maxLengthCount" [formControlName]="config.name" [attr.name]="config.name"></textarea>

    <mat-hint class="w-100" *ngIf="config.maxLengthHint">
      <span>{{config.maxLengthText}}</span>
      <span class="float-right">{{textarea.value?.length || 0}} / {{config.maxLengthCount}}</span>
    </mat-hint>
    <mat-error *ngIf="group.controls[FormControlName].hasError('minlength') && config.showErrorText">
      Min length validate 6
    </mat-error>
    <mat-error *ngIf="group.controls[FormControlName].hasError('required') && group.controls[FormControlName].touched && config.showErrorText">
      Field Required Field
    </mat-error>
  </mat-form-field>
</div> -->

<div [formGroup]="group" class="form-text-area {{config.class}}">
  <div class="default-sub-header text-label">{{config.label | translate}}</div>
  <mat-form-field  [ngClass]="{'input-with-boundary':config.appearance}">
    <textarea  #textarea matInput maxlength="{{config.charLength}}" placeholder="{{config.label | translate}}"
      [formControlName]="config.name" [errorStateMatcher]="matcher" rows="1"></textarea>
      <mat-error 
      *ngIf="group.controls[FormControlName].hasError('pattern')">
      {{'invalidText' | translate}}
    </mat-error>
  </mat-form-field>
</div>
